// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__wH02e","rotating":"button_rotating__LAtyU"};